<template>
	<div class="exercise">
		<div class="exercise-div">
			<div class="exercise-left div">
				<div class="header1">
					<div class="title">本题时间</div>
					<div class="time">{{timecount}}</div>
				</div>
				<div class="center">
					<div class="title">考试试题</div>
					<div class="qlist">
						<div class="qlist-div" style="padding-left: 2rem;" v-for="(item,index) in questionlist" :key="index">
							<span class="left" :class="number==index?'actiy':''">{{index+1}}</span>
							<span class="right">{{item.name}}</span>
						</div>
					
				
						<div class="top" style="padding-left: 2rem;">
							<div class="red"></div>
							<div class="white"></div>
							<div class="red"></div>
							<div>已完成</div>
						</div>
						
						
					</div>
				</div>
			</div>
			<div class="exercise-connet div">
				<div class="exercise-connet-div">
					<div class="left">
						<!-- <div class="table">
							<div class="table-div" v-for="(item,index) in questioninfo.body" :key="index">
								<div class="table-div-div" v-for="(twoitem,two) in item" :key="two">
									<div class="table-div-div-input " v-for="(threeitem,three) in twoitem" :key="three">
										<input 
											type="text" 
											v-if="threeitem.type==0" 
											disabled
											v-model="threeitem.number"
											:style="{'background':threeitem.templateColor}"   />
										<input type="text" 
											@change="wactchNum($event,index,two,three,1)"
											@click="typeactiyClick(index,two,three)"
											v-model="threeitem.number"
											:class="typeactiy==index+two+three ? 'actiy':'' "
										    v-else
											:style="{'background':threeitem.templateColor}"  />
									</div>
									
								</div>
								
							</div>
							
						</div> -->
						<div class="table1">
							<div class="table"  v-if="row==9">
								<img class="imgs2" :src="bagurl" />
								<!-- <div class="table-div" v-for="(item,index) in questioninfo.body" :key="index">
									<div class="table-div-div" v-for="(twoitem,two) in item" :key="two">
										<div class="table-div-div-input " v-for="(threeitem,three) in twoitem" :key="three" :class="typeactiy==index+two+three ? 'actiy':'' ">
											<input 
												type="text" 
												v-if="threeitem.type==0" 
												disabled
												class="inputdisabled"
												v-model="threeitem.number"
												:style="{'background':threeitem.templateColor}"   />
											<input type="text" 
												@change="wactchNum($event,index,two,three,1)"
												@click="typeactiyClick(index,two,three)"
												v-model="threeitem.number"
												:class="typeactiy==index+two+three ? 'actiy':'' "
											    v-else
												:style="{'background':threeitem.templateColor}"  />
										</div>
										
									</div>
								</div> -->
								<div class="tat9">
									<div class="table-div9" v-for="(item,index) in questioninfo.body" :key="index">
										<div class="table-div-div9" v-for="(twoitem,two) in item" :key="two">
											<div class="table-div-div-input9 " v-for="(threeitem,three) in twoitem" :key="three" :class="typeactiy==index+two+three ? 'actiy':'' ">
												<input
													type="number" 
													v-if="threeitem.type==0" 
													disabled
													class="inputdisabled"
													v-model="threeitem.number"
													:style="{'background':threeitem.templateColor}"   />
												<input type="number" 
													@change="wactchNum($event,index,two,three,1)"
													@click="typeactiyClick(index,two,three)"
													v-model="threeitem.number"
													maxlength ='1'
													:class="typeactiy==index+','+two+','+three+','+three  ? 'actiy':'' "
												    v-else
													:style="{'background':threeitem.templateColor}"  />
												
											</div>
											
										</div>
									</div>
									
								</div>
							</div>
							<div class="topic-body-input1"   v-if="row==4" >
								<img class="activebag4" :src="bagurl" />
								<div  class="topic-body-input-div1"  v-for="(template,templateIndex) in questioninfo.body" :key="templateIndex"  >
								
										<div class="topic-body-input-div-div" v-for="(templates,templateIndexs) in template"
											 :key="templateIndexs">
											<label v-for="(templatess,templateIndexss) in templates" :key="templateIndexss"
														>
												<input
													type="text" 
													v-if="templatess.type==0" 
													disabled
													v-model="templatess.number"
													:style="{'background':templatess.templateColor}"   />
												<input type="text" 
													@change="wactchNum($event,templateIndex,templateIndexs,templateIndexss,1)"
													@click="typeactiyClick(templateIndex,templateIndexs,templateIndexss)"
													
													v-model="templatess.number"
													:class="typeactiy==templateIndex+','+templateIndexs+','+templateIndexss+','+templateIndexss  ? 'actiy':'' "
													
													v-else
													:style="{'background':templatess.templateColor}"  />
											</label>
										</div>
								</div>
							</div>
							<div class="topic-body-input2"   style="margin-top: 6.2rem; margin-left: 9rem;" v-if="row==6" >
								<img class="activebag5" :src="bagurl" />
								<div  class="topic-body-input-div2"  v-for="(item,index) in questioninfo.body" :key="index"  >
									<div class="topic-body-input-div-div" v-for="(twoitem,two) in item"
										 :key="two">
										<label v-for="(threeitem,three) in twoitem" :key="three">
											<input
												type="text" 
												v-if="threeitem.type==0" 
												disabled
												v-model="threeitem.number"
												:style="{'background':threeitem.templateColor}"   />
											<input type="text" 
												@change="wactchNum($event,index,two,three,1)"
												@click="typeactiyClick(index,two,three)"
												v-model="threeitem.number"
												
												:class="typeactiy==index+','+two+','+three+','+three  ? 'actiy':'' "
												
											    v-else
												:style="{'background':threeitem.templateColor}"  />
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="right" v-if="touch==1">
						<div class="title"></div>
						<div class="assist">
							<div v-for="(item,index) in assist"  :key="index" @click="touchArrClick(item)">{{item}}</div>
						</div>
					</div>
				</div>
				<div class="top">
					<div @click="resetClick()">清空 reset</div>
					<div @click="saveClick()">保存</div>
					<div @click="touchClick()">触摸 touch</div>
				</div>
			</div>
			
		</div>
		
		<div class="middle">
			<div class="div">
				<div class="red" @click="submit()">提交试卷</div>
				<div @click="upClick()" v-if="forbidden">上一题</div>
				<div v-if="!forbidden">上一题</div>
				<div @click="belowClick()" class="red" v-if="forbidden">下一题</div>
				<div @click="belowClick()"  class="red"  v-if="!forbidden">下一题</div>
			</div>
			
		</div>
		
	
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				game_id: '',
				questionlist : [],  //全部
				questioninfo : [],   //单条
				assist       : [1,2,3,4,5,6,7,8,9],
				page         : 1,
				count        : 20,
				touch        : 0,   //触摸
				typeactiy    : '',
				typeactiyarr : [],
				number       : 0,   //第几题
				start_time   : '',
				start_time1  : '',  //第一次进来的时间
				end_time     : '',
				info         : [],
				timecount    : '', //倒计时
				seconds      : 360, // 10天的秒数
				timestart    : '',
				tabtype      : 1,
				exerciselist : [],
				forbidden:true,
				row : 9,
				bagurl : ''
			}	
		},
		created() {
			var  query = this.$route.query;
			this.game_id = query.id;
			
			this.start_time  = this.start_time1 = new Date().getTime();
			this.getlist(query.id);
			this.time();
			// this.stopF5Refresh();  //禁用刷新
		},
	    methods: {
			currentChangeHandle(val) {
				let that = this;
				that.page = val;
				that.getlist(that.game_id);
			},
			touchClick(){   //触摸
				this.touch = this.touch==0 ? 1 : 0;
			},
			typeactiyClick(val, val1,val2){
				this.typeactiy	 = val+','+val1+','+val2+','+val2;
				this.typeactiyarr= [val,val1,val2];
			},
			touchArrClick(e){  //触摸输入
				let that  = this;
				var arr   = that.typeactiyarr;
				that.questioninfo['body'][arr[0]][arr[1]][arr[2]]['number'] = e;
				that.questioninfo['body'][arr[0]][arr[1]][arr[2]]['type'] = parseInt(1);
				console.log(that.questioninfo);
			},
			wactchNum(e, val, val1,val2,type) {   //键盘输入
				let that = this;
				if(that.touchType==1) return;
				if(!e.target.value) return;
				that.questioninfo['body'][val][val1][val2]['number'] = parseInt(e.target.value);
				that.questioninfo['body'][val][val1][val2]['type'] = parseInt(type);
				that.questionlist[that.number] = that.questioninfo;
				console.log(that.questioninfo['body']);
			},
			upClick(){  //上一题
				let that = this;
				that.forbidden =false;
				this.$notify({
				        
				          message: '请等待',
				          type: 'success'
				        });
				if(that.number==0){
					that.forbidden =true;
					that.$message({showClose: true,message: '已经是第一题',type: 'warning'});return;
				}
				async function testAsync() {
				    that.end_time  = new Date().getTime();
				    await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
				    	that.questioninfo.start_time = that.start_time;
				    	that.questioninfo.end_time   = that.end_time;
				    	that.questioninfo.grade      = res.data;
				    	that.questionlist[that.number] = that.questioninfo;
						
						that.$http('post','/api/v1/game/temporarystore',{arr:JSON.stringify(that.questionlist),id:that.game_id}) .then(function (res) {
							that.forbidden =true;
						});
						
				    });
				}
				testAsync();
				that.number = that.number  - 1;
				that.questioninfo = that.questionlist[that.number];
				that.row          = that.questioninfo['template']['row'];
				that.bagurl          = that.questioninfo['template']['img'];
				
			},
			belowClick(){  //下一题
				let that = this;
				that.forbidden =false;
				this.$notify({
				         
				          message: '请等待',
				          type: 'success'
				        });
				console.log(11111111111111111111 );
				if(that.number ==that.questionlist.length-1){
					that.forbidden =true;
					that.$message({showClose: true,message: '已经是最后一题',type: 'warning'});return;
				}else{
					console.log(222222222222222222 );
					testAsync();
					async function testAsync() {
					    that.end_time  = new Date().getTime();
					    await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
					    	that.questioninfo.start_time = that.start_time;
					    	that.questioninfo.end_time   = that.end_time;
					    	that.questioninfo.grade      = res.data;
							
					    	that.questionlist[that.number] = that.questioninfo;
							
							that.start_time  = new Date().getTime();
							
							that.$http('post','/api/v1/game/temporarystore',{arr:JSON.stringify(that.questionlist),id:that.game_id}) .then(function (res) {  
								
								that.number = that.number  + 1;
								that.questioninfo = that.questionlist[that.number];
								that.row          = that.questioninfo['template']['row'];
								that.bagurl          = that.questioninfo['template']['img'];
								
								that.forbidden =true;
							});
						
							
					    });
					}
					
					
				}
						
				
			},
			resetClick(){  //清空reset
				let that = this;
				this.$confirm('清空后当前题目填写答案不再保留，谨慎操作', '确认清空吗', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					   that.typeactiy    = '';
					   that.typeactiyarr = [];
					   that.getlist(that.game_id);
					});
			},
			submit(){ //提交
				let that = this;
				async function testAsync() {
					that.end_time  = new Date().getTime();
					await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
						that.questioninfo.start_time = that.start_time;
						that.questioninfo.end_time   = that.end_time;
						that.questioninfo.grade      = res.data;
						that.questionlist[that.number] = that.questioninfo;
						that.$http('post','/api/v1/game/temporarystore',{arr:JSON.stringify(that.questionlist),id:that.game_id}) .then(function (res) {
							that.$http('post','/api/v1/game/submit',{id:that.game_id}) .then(function (res) {
								if(res.code==200){
									localStorage.removeItem(that.game_id+'number1');
									localStorage.removeItem(that.game_id+'questionlist1');
									localStorage.removeItem(that.game_id+'seconds1');
									that.$message({message: res.msg,type: 'success'});
									that.$router.push('/index');	
								}else{
									that.$message({message: res.msg,type: 'error'});
								}
							
							});
							
						
						});
						
						
					});
				}
				testAsync();
			},
			getlist(id){
				let that = this;
				that.$http('get','/api/v1/question/list',{form:1,game_id:id,page:that.page,size:30}) .then(function (res) {  //
					if(res.code==400){
						that.$message({message: res.msg,type: 'error'});	
						 that.$router.push('/index');	
						 return;
					}
					that.questionlist = res.data.list;
					that.questionlist.forEach(item=>{
						item['start_time']  = '';
						item['end_time']  = '';
						item['grade']  = '';
					});
					that.count        = res.data.count;
					var classify_idnumber       = that.game_id+'number1';
					var classify_idquestionlist = that.game_id+'questionlist1';
				
					if(localStorage.getItem(classify_idquestionlist)){
						var json =JSON.parse(localStorage.getItem(classify_idquestionlist));
						var data2 = [];            // 某种意义上来说，数组也是object
						for (let i in json) {
							let o = {};
							o = json[i];
							data2.push(o)
						}
						that.questionlist   = data2;
						that.number         = localStorage.getItem(classify_idnumber) ? parseInt(localStorage.getItem(classify_idnumber)) : 0;
					}
					that.questioninfo = that.questionlist[that.number];
					that.row          = that.questioninfo['template']['row'];
					that.bagurl          = that.questioninfo['template']['img'];
					
				});
				that.$http('get','/api/v1/game/startexam',{id:id}) .then(function (res) {  //获取倒计时时间
					if(res.code==200){
						that.seconds =res.data.time;
					}else{
						that.$message({message: res.msg,type: 'error'});	
						 that.$router.push('/index');	
						return;
					}
					
				
				});
				
				
				
			},
			saveClick(){
				let that = this;
				async function testAsync() {
				    that.end_time  = new Date().getTime();
				    await that.$http('post','/api/v1/question/answer',{questioninfo:that.questioninfo}) .then(function (res) {  //计算分数
				    	that.questioninfo.start_time = that.start_time;
				    	that.questioninfo.end_time   = that.end_time;
				    	that.questioninfo.grade      = res.data;
				    	that.questionlist[that.number] = that.questioninfo;
						that.$http('post','/api/v1/game/temporarystore',{arr:JSON.stringify(that.questionlist),id:that.game_id}) .then(function (res) {
						});
						localStorage.setItem(that.game_id+'number1',that.number);
						localStorage.setItem(that.game_id+'questionlist1',JSON.stringify(that.questionlist));
						localStorage.setItem(that.game_id+'seconds1',that.seconds);
						that.$message({message: '保存成功',type: 'success'});	
				    });
				}
				testAsync();
				
			},
			//定时器没过1秒参数减1
			time() {
				let that = this;
				
				that.timestart = setInterval(() => {
					that.seconds -= 1
					
					that.countDown()
					if(that.seconds == 600){
						const h = that.$createElement;
						that.$notify.warning({
							title: '距离考试结束还有10分钟',
							message: h('i', { style: 'color: teal'}, '请注意时间，考试结束系统将自动提交')
						});
					}
					if(that.seconds==0){
						that.submit();
					}
					// console.log(that.seconds)
				}, 1000)
			},
			// 天 时 分 秒 格式化函数
			countDown() {
				let d = parseInt(this.seconds / (24 * 60 * 60))
				d = d < 10 ? "0" + d : d
				let h = parseInt(this.seconds / (60 * 60) % 24);
				h = h < 10 ? "0" + h : h
				let m = parseInt(this.seconds / 60 % 60);
				m = m < 10 ? "0" + m : m
				let s = parseInt(this.seconds % 60);
				s = s < 10 ? "0" + s : s
				this.timecount =  h + '时' + m + '分' + s + '秒'
			},
			stopF5Refresh() {
				window.onbeforeunload = function(e) {
				  var dialogText = 'CSDN 吴小迪';
				  e.returnValue = dialogText;
				  return dialogText;
				};
			      document.onkeydown = function(e) {
			        var evt = window.event || e;
			        var code = evt.keyCode || evt.which;
			        //屏蔽F1---F12
			        if (code > 111 && code < 124) {
			          if (evt.preventDefault) {
			            evt.preventDefault();
			          } else {
			            evt.keyCode = 0;
			            evt.returnValue = false;
			          }
			        }
			      };
			      //禁止鼠标右键菜单
			      document.oncontextmenu = function(e) {
			        return false;
			      };
			      //阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
			      history.pushState(null, null, window.location.href);
			      window.addEventListener("popstate", function() {
			        history.pushState(null, null, window.location.href);
			      });
			},
		},
		
		
	}	
</script>

<style lang="less">
	@import  '../../../common/css/exercise.less';	
	.exercise {
		// background-color: red;
		.exercise-div {
			width: 63%;
		}
		.middle {
			width: 63%;
		}
	}
	
</style>
